import { TopBannerUsers } from '../types';

export interface GetTopBannerUsersParams {
  isEnterprise: boolean;
  isFinance: boolean;
  isFreemium: boolean;
  isLoggedIn: boolean;
  isPartnerClient: boolean;
  isPremium: boolean;
  isPromo: boolean;
}

export const getTopBannerUsers = ({
  isEnterprise,
  isFinance,
  isFreemium,
  isLoggedIn,
  isPartnerClient,
  isPremium,
  isPromo,
}: GetTopBannerUsersParams) => {
  const users: TopBannerUsers[] = ['all'];

  if (!isLoggedIn) {
    users.push('public');

    return users;
  }

  users.push('private');

  if (isFinance || isPartnerClient) {
    return users;
  }

  if (isPromo) {
    users.push('promo');

    return users;
  }

  if (isEnterprise) {
    users.push('enterprise');

    return users;
  }

  if (isPremium) {
    users.push('premium');

    return users;
  }

  if (isFreemium) {
    users.push('freemium');

    return users;
  }

  return users;
};
